<template>
  <!-- 消息通知-->
  <div>
    <div class="noticeTitle" v-for="(item,index)  in noticeList" :title="item.title" :name="index" :key="index"
         @click="seeMore(index)">
      <el-tag type="success" v-if="item.status == 1">已读</el-tag>
      <el-tag type="danger" v-if="item.status == 0">未读</el-tag>
      <el-span>{{ item.title | ellipsis }}</el-span>
      <el-tag type="warning">{{ item.createTime | formatTime }}</el-tag>
      <!-- <el-tag type="info" v-if="item.remark">{{item.remark}}</el-tag>           -->
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryParams.pageNum"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="queryParams.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <el-dialog title="详情" :visible.sync="moreOpen" width="780px" append-to-body>
      {{  enterpriseName }} : <span v-html="this.moreText" style="font-size: 16px;"></span>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="question()">回复</el-button>
        <el-button @click="cancel1">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 添加或修改回复对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="回复内容" prop="content">
          <el-input type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    v-model="form.content"
                    placeholder="请输入要回复的内容"
                    clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>

    </el-dialog>

  </div>
</template>
<script>
import {query} from "@/api/register/register";
import {getInfo} from "@/api/login";
import {formatDate} from '@/utils/date';
import {queryByPage, updateById} from '@/api/words/words';
import {addNew} from '@/api/words/reply';
import {mapGetters} from "vuex";

export default {
  name: "newsBar",
  props: {
    userId: {
      type: Number,
      required: true,
      /*default:this.userId*/
    }
  },
  data() {
    return {
      //公司名称
      enterpriseName: undefined,
      //发件人
      userId: undefined,
      //对话框
      open: false,
      //对话框标题
      title: "",
      //消息标题
      newsTitle: "",
      noticeList: [],
      //消息详情
      moreText: '',
      //类别Id
      categoryId: undefined,
      //接收回复人id
      fromUserId: undefined,
      moreOpen: false,
      total: 0,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        toUserId: this.userId
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        title: [
          {required: true, message: "标题名称不能为空", trigger: "blur"}
        ],
        content: [
          {required: true, message: "回复内容不能为空", trigger: "blur"}
        ],
      }
    };
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'token',
     /* 'userId'*/
    ])
  },
  methods: {
    getUserId() {
      getInfo().then((response) => {
        /*this.userId = response.data.userId;*/
      })
    },
    // 表单重置
    reset() {
      this.form = {
        title: undefined,
        content: undefined,
        /*categoryId: undefined,
        toUserId:undefined*/
      };
      this.resetForm("form");
    },
    /** 回复按钮操作 */
    question() {
      this.reset();
      this.open = true;
      this.title = "回复内容";
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate(valid => {
        if (valid) {
          /*console.log(this.userId)*/
          this.form.userId = this.userId;
          this.form.fromUserId = this.fromUserId;
          this.form.categoryId = this.categoryId;
          this.form.title = this.newsTitle;
          console.log(this.form)
          let formData = this.qs.stringify(this.form);
          addNew(formData).then(response => {
            this.$message({
              type: 'success',
              message: '发送成功!'
            });
            this.open = false;
            this.getList();
            this.cancel1();
            this.cancel();
          });
        }
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    cancel1() {
      this.moreOpen = false;
    },
    openInfo() {
      this.open = true;
      this.getList();
    },
    //分页切换每页条数函数
    handleSizeChange(val) {
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = val;
      this.getList();
    },
    //当前页改变函数
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    //获取消息信息
    getList() {
      this.queryParams.toUserId = this.userId;
      queryByPage(this.queryParams).then((response) => {
        this.noticeList = response.data.list;
        this.total = response.data.total;
        this.data = response.data.list[0];
      });
    },
    //查看消息详情
    seeMore(v) {

      //查询发件人公司名称
      query(this.noticeList[v].userId).then(response =>{
        this.enterpriseName = response.data.enterpriseName;
      })

      //提供回复表单信息
      this.moreText = this.noticeList[v].content;
      this.categoryId = this.noticeList[v].categoryId;
      this.fromUserId = this.noticeList[v].userId;
      this.newsTitle = this.noticeList[v].title;
      this.moreOpen = true;
      if (this.noticeList[v].status == 0) {
        this.form = this.noticeList[v];
        this.form.status = "1";
        updateById(this.noticeList[v].wordsId, this.form).then((response) => {
        })
      }
      this.getList();

    }
  },
  created() {
    this.getUserId();
    this.userId = this.props.userId;

  },
  mounted() {
    this.getList();
  },
  filters: {
    ellipsis(value) {
      if (!value) return '';
      if (value.length > 40) {
        return value.slice(0, 40) + '...'
      }
      return value
    },
    formatTime(time) {
      if (time == null || time === '') {
        return 'N/A';
      }
      let date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd')
    },
  },
};
</script>
<style scoped>
.noticeTitle {
  margin: 10px 10px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/NoticeBar/news.vue